<template>
    <IndexBase @auth="onAuth($event)" action="SummaryReport" controller="Report"></IndexBase>

    <Card>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" showGridlines filterDisplay="row" sortMode="multiple" removableSort
                       :value="dataModel" 
                       :loading="!dataModel || loading"
                       resizableColumns
                       columnResizeMode="fit"
                       :paginator="true"
                       :rows="10"
                       :lazy="true"
                       v-model:first="this.start"
                       @state-restore="onStateRestore($event)"
                       @page="onPage($event)"
                       @sort="onSort($event)"
                       @filter="onFilter($event)"
                       v-model:filters="filters"
                       :totalRecords="totalRecords"
                       dataKey="Id" 
                    >
                    <template #header>
                        <div class="p-card-title center mb-5">
                          {{$t('summary_report_wo')}}
                            <Button  :label="$t('export')" icon="pi pi-print" class="p-button-help p-button-sm" v-if="dataModel" @click="onExport" style="float: right;"/>
                         </div>

                        <div class="p-inputtext-sm p-fluid filters-section">
                            <div class="grid">
                                <div class="col-12">
                                    <!-- Row 1: Report Generate Date (label left, inputs right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('generate_date_wo')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <div class="grid">
                                                <div class="col-6">
                                                    <DatePicker name="From_Date" v-model="From_Date" :placeholder="$t('from_date')"  
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                                </div>
                                                <div class="col-6">
                                                    <DatePicker name="Request_Date" v-model="To_Date" :placeholder="$t('to_date')" 
                                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Row 2: WO Number filter (label left, input + search right) -->
                                    <div class="grid mb-2 filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('no_wo')}}</label>
                                        </div>
                                        <div class="col-9 filter-input">
                                            <CustomMultiSelect class="full-width p-inputtext-sm" name="listtransacton"
                                                v-model="listtransacton"
                                                :url="$API_URL + 'list/listWo'"
                                                :params="{}"
                                                :minLength="0"
                                                :filter="true"
                                                :placeholder="$t('no_wo')"/>
                                        </div>
                                        <div class="col-1 flex align-items-center">
                                            <Button icon="pi pi-search" class="p-button-primary p-button-sm" @click="filterDataTable" />
                                        </div>
                                    </div>

                                    <!-- Row 3: View Data (label left, MultiSelect right) -->
                                    <div class="grid filter-row">
                                        <div class="col-2 filter-label">
                                            <label>{{$t('view_data')}}</label>
                                        </div>
                                        <div class="col-10 filter-input">
                                            <MultiSelect class="full-width p-inputtext-sm" v-model="selectedColumns"
                                                :options="columnOptions"
                                                optionLabel="text"
                                                optionValue="id"
                                                display="chip"
                                                :filter="true"
                                                :placeholder="$t('visible_columns')"
                                                @change="onColumnsChange" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    
                    <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                        <template #header>
                            <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                        </template>
                        <template #body="slotProps">
                           <p class="center">{{ slotProps.index +=1 }}</p> 
                         </template>
                    </Column>
                
                    <Column v-if="showColumn('Wo_Number')" field="Wo_Number" :header="$t('no_wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Type')" field="WO_Type" :header="$t('wo_type')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('wo_type')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Number_Main')" field="WO_Number_Main" :header="$t('Link_Main_Wo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Link_Main_Wo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Company_Code')" field="Company_Code" :header="$t('company_code')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('company_code')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Main_Data')" field="Main_Data" :header="$t('main_data')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('main_data')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('No_SPO')" field="No_SPO" :header="$t('no_spo')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('no_spo')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WBS_Allocation')" field="WBS_Allocation" :header="$t('WBS_Allocation')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('WBS_Allocation')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Requester')" field="Requester" :header="$t('requester')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('requester')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Department_Code')" field="Department_Code" :header="$t('department')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('department')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Work_Group')" field="Work_Group" :header="$t('Work_Group')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Work_Group')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Work_Description')" field="Work_Description" :header="$t('Work_Description')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Work_Description')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC')" field="PIC" :header="$t('pic')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('pic')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Created_Date')" field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Created_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Rev')" field="Rev" :header="$t('WO_Revision_No')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('WO_Revision_No')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Status_Release')" field="Status_Release" :header="$t('Status_Release_WO')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Status_Release_WO')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC1')" field="PIC1" :header="$t('PIC_Releaser_1')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PIC_Releaser_1')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC2')" field="PIC2" :header="$t('PIC_Releaser_2')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PIC_Releaser_2')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC3')" field="PIC3" :header="$t('PIC_Releaser_3')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PIC_Releaser_3')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Release_Date')" field="Release_Date" :header="$t('Release_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Release_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Release_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Planned_Start_Date')" field="Planned_Start_Date" :header="$t('Planned_Start_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Planned_Start_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Planned_Start_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Planned_Finish_Date')" field="Planned_Finish_Date" :header="$t('Planned_Finish_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Planned_Finish_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Planned_Finish_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Act_Start_Date')" field="Act_Start_Date" :header="$t('Act_Start_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Act_Start_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Act_Start_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Last_Update_Date')" field="Last_Update_Date" :header="$t('Last_Update_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Last_Update_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Last_Update_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Progress')" field="Progress" :header="$t('Progress')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Progress')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('WO_Finish_Date')" field="WO_Finish_Date" :header="$t('WO_Finish_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('WO_Finish_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.WO_Finish_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Status_Progress')" field="Status_Progress" :header="$t('Status_Progress')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Status_Progress')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                        <template #body="{data}">
                            <span :style="statusProgressStyle(data)">{{ data.Status_Progress }}</span>
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC_CLOSING1')" field="PIC_CLOSING1" :header="$t('PIC_Closer_1')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PIC_Closer_1')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('PIC_CLOSING2')" field="PIC_CLOSING2" :header="$t('PIC_Closer_2')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('PIC_Closer_2')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Closed_Date')" field="Closed_Date" :header="$t('Closed_Date')" dataType="date" :sortable="false">
                        <template #filter="{filterModel,filterCallback}">
                            <DatePicker :placeholder="$t('Closed_Date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value" @date-select="filterCallback()" />
                        </template>
                        <template #body="{data}">
                            {{ this.$formatDate(data.Closed_Date)}}
                        </template>
                    </Column>

                    <Column v-if="showColumn('Status')" field="Status" :header="$t('Status')  + ' (Planned VS Actual)'" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('Status')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>

                    <Column v-if="showColumn('Duration')" field="Duration" :header="$t('WO_Duration')" :sortable="false" :filter="false">
                        <template #filter="{filterModel,filterCallback}">
                            <InputText type="text" :placeholder="$t('WO_Duration')" v-if="filterModel" v-model="filterModel.value" @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"  />
                        </template>
                    </Column>
                    
            </DataTable>
        </template>
    </Card>

   
</template>

<script>
    function getDefaultDates() {
        let fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        fromDate.setHours(0, 0, 0, 0);

        let toDate = new Date();
        toDate.setHours(23, 59, 59, 999);

        return { fromDate, toDate };
    }

    export default {
        name: "SummaryReportWo",
        components: {
        },
        data() {
            const { fromDate, toDate } = getDefaultDates();
            return {
                dataModel: null,
                loading: true,
                totalRecords: 0,
                start: 0,
                stateKey: 'pas-state-summaryreportwo-' + this.$store.getters.getUsername,
                role: this.$store.getters.getRole,
                isAdmin: this.$store.getters.getIsAdmin,
                isUser: this.$store.getters.getIsUser,
                isTransporter: this.$store.getters.getIsTransporter,
                isDriver: this.$store.getters.getIsDriver,
                sorts: null,
                lazyParams: {},
                filters: null,
                stateFilters: null,
                editorPath: "/ReleaseMatrix/Editor",
                dataUrl: "Report/listsummaryreportwo",
                exportUrl : "report/exportsummaryreportwo",
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canView: false,
                changeval : null,
                From_Date : fromDate,
                To_Date : toDate,
                listtransacton: [],
                header: null,
                // column visibility control
                columnOptions: [],
                // list the fields you want visible by default (when user has no saved choice)
                defaultVisibleColumns: ['Wo_Number','WO_Type', 'WO_Number_Main', 'Company_Code','Main_Data', 
                                        'No_SPO', 'WBS_Allocation', 'Requester', 'Departement_Code','Work_Group', 'Work_Description', 
                                        'PIC', 'Created_Date', 'Release_Date', 'Planned_Start_Date', 'Planned_Finish_Date', 'Act_Start_Date', 
                                        'Last_Update_Date', 'WO_Finish_Date', 'Status_Progress', 'Closed_Date', 'Status', 'Duration', 'Department_Code','Progress'],
                selectedColumns: [],
                // retry mechanism to wait for DataTable columns to be available
                _columnOptionsRetries: 0,
            }
        },
        methods: {
            onColumnsChange(val){
                // Prevent empty selection: if user unticks all, restore all columns and warn
                if(!this.selectedColumns || this.selectedColumns.length === 0){
                    // restore to all available columns
                    this.selectedColumns = this.columnOptions.map(o=>o.id);
                    if(this.$toast) this.$toast.add({ severity: 'warn', summary: 'Columns', detail: 'At least one column must be visible. Restored all columns.', life: 3000 });
                }
            },
            filterDataTable(){
                this.loadLazyData();
            },
            onChnageIsDeleted(event){
                this.changeval = event;
            },
            onAuth(event) {
                this.canCreate = event.canCreate;
                this.canEdit = event.canEdit;
                this.canDelete = event.canDelete;
                this.canView = event.canView;
            },
            onPage(event) {
                this.start = event.first;
                this.loadLazyData();
            },
            onSort(event) {
                this.sorts = event.multiSortMeta;
                this.loadLazyData();
            },
            onFilter() {
                this.loadLazyData();
            },
            onSelect(event){
                this.selectedRow = event.data;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            editor(mode, id) {
                this.$router.push({ path: this.editorPath, query: { mode: mode, id: id } });
            },
            filter(mode) {
                this.$router.push({ path: this.filterPath, query: { mode: mode} });
            },
            sidebarMessage(event){
                this.$toast.add(event);
            },
            loadLazyData() {
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;
            
                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };
            
                var self = this;
                this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                    .then((response) => {
                        if (response.data.success) {
                            this.dataModel = response.data.data;
                            // capture header if API returns it in different shapes
                            this.header = response.data.header || (response.data.data && response.data.data.header) || this.header;
                            this.totalRecords = response.data.totalRecords;
                        }
                        else {
                            self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        //this.$emit('unblock-ui');
                        this.loading = false;
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        //this.$emit('unblock-ui');
                        self.loading = false;
                    });
            },
            setFilters() {
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                for (var i = 0; i < exportable.length; i++) {
                    var filterValue = null;
                    if(this.stateFilters){
                        var field = this.stateFilters[exportable[i].props.field];
                        if(field) filterValue = field.value;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
            },
            // build columnOptions from DataTable columns and restore saved selection
            setColumnOptions(){
                try{
                    const cols = (this.$refs.dt && this.$refs.dt.columns) ? this.$refs.dt.columns.filter(c => c.props.field) : [];
                    // If columns are not yet available, retry a few times (DataTable may render after mounted)
                    if((!cols || cols.length===0) && this._columnOptionsRetries < 6){
                        this._columnOptionsRetries++;
                        setTimeout(() => { try{ this.setColumnOptions(); }catch(e){} }, 50);
                        return;
                    }
                    this.columnOptions = cols.map(c => {
                        let header = c.props.header;
                        let text = '';
                        if (header && typeof header === 'string') {
                            text = header;
                        } else {
                            try {
                                const translated = this.$t && this.$t(c.props.field);
                                text = (translated && translated !== c.props.field) ? translated : c.props.field;
                            } catch (e) {
                                text = c.props.field;
                            }
                        }
                        return { id: c.props.field, text };
                    });
                    // apply configured defaults (do NOT persist selection in localStorage)
                    const availableIds = this.columnOptions.map(o=>o.id);
                    const initial = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = initial.length ? initial : availableIds;
                }catch(e){
                    // fallback: show all
                    this.columnOptions = [];
                    this.selectedColumns = [];
                }
            },
            showColumn(field){
                if(!this.selectedColumns || this.selectedColumns.length===0) return true;
                return this.selectedColumns.includes(field);
            },
            onStateRestore(event) {
                this.start = event.first;
                this.stateFilters = event.filters;
                this.sorts = event.multiSortMeta;
            },
            editOrder(){
                this.$router.push({ path: this.editorPath, query: { mode: this.$FORM_MODE_EDIT, id: this.selectedRow[0].Id } });
            },
             onModalClose(){
                this.loadLazyData();
            },
            clearFilter(){
                this.filters = {};
                var exportable = this.$refs.dt.columns.filter(c => c.props.field);
                this.changeval = null;
                
                const { fromDate, toDate } = getDefaultDates();
                this.From_Date = fromDate;
                this.To_Date = toDate;
                this.listtransacton = [];

                for (var i = 0; i < exportable.length; i++) {
                    var fieldName = exportable[i].props.field;
                    var filterValue = "";
                    if(fieldName.includes("Date") || fieldName.includes("Start_Work") || fieldName.includes("Finish_Work")){
                        filterValue = null;
                    }
                    this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
                }
                // reset selected columns to defaults (or all available if defaults not applicable)
                try{
                    const availableIds = exportable.map(c => c.props.field);
                    const defaults = (this.defaultVisibleColumns || []).filter(d => availableIds.includes(d));
                    this.selectedColumns = defaults.length ? defaults : availableIds;
                }catch(e){}

                this.loadLazyData();
            },
            onExport(){
                this.loading = true;
                this.selectedRow = null;
                const { fromDate, toDate } = getDefaultDates();
                if (!this.From_Date) this.From_Date = fromDate;
                if (!this.To_Date) this.To_Date = toDate;

                this.lazyParams = {
                    start: this.start,
                    sorts: this.dataSort,
                    filters: this.dataFilter,
                    from_date : this.From_Date,
                    to_date : this.To_Date,
                    listtransacton: this.listtransacton,
                    selectedColumns: this.selectedColumns || []
                };

                var self = this;

                this.$axios.post(this.$API_URL + this.exportUrl, this.lazyParams, {
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                    })
                    .then((response) => {
                        var contentDisposition = response.headers["content-disposition"];
                        var matchName = contentDisposition.match(/filename\s*=\s*"?(.+)"?/);
                        var filename = matchName[1].split(';')[0];
                        
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        
                    })
                    .catch(function (err) {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 60000});
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
            ,
            statusProgressStyle(data){
                // prefer per-row indicator in dataModel
                const rowIndicator = data && (data.Indicator_Status_Progress || data.indicator_status_progress || data.IndicatorStatusProgress);
                if (rowIndicator) {
                    return 'background-color: #ffc0cb; color: #000; padding:2px 6px; border-radius:4px; display:inline-block;';
                }
                return '';
            }
        },
        mounted() {
            this.$emit('unblock-ui');
            this.setFilters();
            this.$nextTick(() => {
                try{ this.setColumnOptions(); }catch(e){}
                // Inline fallback to ensure header spacing/styles show regardless of external CSS cascade
                try{
                    const headerEl = document.querySelector('.p-inputtext-sm.p-fluid');
                    if(headerEl){
                        headerEl.style.paddingBottom = '1rem';
                        headerEl.style.marginBottom = '1rem';
                        headerEl.style.borderBottom = '1px solid #eef2f5';
                    }
                }catch(e){}
            });
            this.loadLazyData();
            this.$showToast();
        },
        computed: {
            dataFilter() {
                var h = [];
                if (this.filters) {
                    for (const [key, value] of Object.entries(this.filters)) {
                        h.push({
                            field: key ? key : null,
                            value: value.value,
                            matchMode: value.matchMode
                        });
                    }
                }
                return h;
            },
            dataSort() {
                var h = [];
                if (this.sorts) {
                    for (var x = 0; x < this.sorts.length; x++) {
                        h.push({
                            field: this.sorts[x].field,
                            order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                        });
                    }
                }
                return h;
            },
            filterBadge(){
                var badgeNumber = 0;

                if(this.From_Date!=null) badgeNumber+=1;
                if(this.To_Date!=null) badgeNumber+=1;

                this.dataFilter.filter(function(item) {                    
                    if(item.value){
                        badgeNumber++;
                    }
                });

                return badgeNumber;
            }
        },
    }
</script>

<style scoped>
/* keep minimal overrides if needed */
    .p-card .p-card-content{
        margin:0!important;
        padding: 0 !important;
    }
    .center{
        text-align: center;
    }
    /* make header title centered */
    .p-card-title.center {
        text-align: center;
        width: 100%;
    }
    /* align labels on left and inputs on right */
    .filters-section .filter-row {
        align-items: center;
    }
    .filters-section .filter-label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 0.75rem;
    }
    .filters-section .filter-input {
        display: flex;
        align-items: center;
    }
    .filters-section .filter-row .p-button {
        margin-left: 0.25rem;
    }
    /* ensure filter section uses full available width */
    .filters-section {
        width: 100%;
        max-width: none;
    }
    /* ensure components with full-width class actually expand */
    .filters-section .full-width {
        width: 100% !important;
    }
        /* ensure header-defined widths apply to body when resizing */
        .p-datatable .p-datatable-table {
            table-layout: auto;
        }
    .p-datatable .p-datatable-thead th {
        white-space: normal;
    }
    .p-datatable .p-datatable-tbody td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>